module.exports = __webpack_public_path__ + "static/media/Osahon Akpata Pic.2b9d6662.jpg";